import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import UserLayout from '@/layouts/UserLayout';
import BasicLayout from '@/layouts/BasicLayout';
import NotFound from '@/pages/NotFound';

// 根路径守卫: 有 token 进 Dashboard, 没有进登录
// 不用 JSX 写法 (这文件是 .js, vite/rollup 解析不动 JSX), 用 createElement
const RootGate = function () {
  var tok = sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
  return React.createElement(Redirect, { to: tok ? '/dashboard' : '/user/login' });
};

// 路由级 code-split: 每个页面独立 chunk, 首屏只下载当前路由相关代码
const UserLogin = lazy(() => import('@/pages/UserLogin'));
const AdminLogin = lazy(() => import('@/pages/admin'));
const UserRegister = lazy(() => import('@/pages/UserRegister'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const users = lazy(() => import('@/pages/users'));
const ProjectList = lazy(() => import('@/pages/ProjectList'));
const TypeManager = lazy(() => import('@/pages/TypeManager'));
const Approval = lazy(() => import('@/pages/Approval'));
const PersonalApproval = lazy(() => import('@/pages/PersonalApproval'));
const OutputExcel = lazy(() => import('@/pages/OutputExcel'));
const brand = lazy(() => import('@/pages/brand'));
const Provider = lazy(() => import('@/pages/Provider'));
const ContractList = lazy(() => import('@/pages/ContractList'));
const ContractDetailList = lazy(() => import('@/pages/ContractDetailList'));
const PurchaseList = lazy(() => import('@/pages/PurchaseList'));
const ProviderList = lazy(() => import('@/pages/ProviderList'));
const contractManage = lazy(() => import('@/pages/contractManage'));
const BadDebtContractList = lazy(() => import('@/pages/BadDebtContractList'));
const contractDashboard = lazy(() => import('@/pages/contractDashboard'));
const ProjectCostReport = lazy(() => import('@/pages/ProjectCostReport'));
const ContractInvoiceList = lazy(() => import('@/pages/ContractInvoiceList'));
const ContractReceiveAmountList = lazy(() => import('@/pages/ContractReceiveAmountList'));
const UnpaidReminder = lazy(() => import('@/pages/UnpaidReminder'));
const PurchaseContractList = lazy(() => import('@/pages/PurchaseContractList'));
const PurchaseInvoiceReminder = lazy(() => import('@/pages/PurchaseInvoiceReminder'));
const FinancePayment = lazy(() => import('@/pages/FinancePayment'));
const SupplierInvoiceLibrary = lazy(() => import('@/pages/SupplierInvoiceLibrary'));
const InvoiceComparison = lazy(() => import('@/pages/InvoiceComparison'));
const DataInspect = lazy(() => import('@/pages/DataInspect'));
const AgentChat = lazy(() => import('@/pages/AgentChat'));
const ContractTaxBreakdown = lazy(() => import('@/pages/ContractTaxBreakdown'));
const StockManage = lazy(() => import('@/pages/StockManage'));
const RoleManage = lazy(() => import('@/pages/RoleManage'));
const MainCompanyManage = lazy(() => import('@/pages/MainCompanyManage'));
const DataDictionary = lazy(() => import('@/pages/DataDictionary'));
const EmployeeContract = lazy(() => import('@/pages/EmployeeContract'));
const CompanyContract = lazy(() => import('@/pages/CompanyContract'));
const CompanyExpenseInvoice = lazy(() => import('@/pages/CompanyExpenseInvoice'));
const DocumentLibrary = lazy(() => import('@/pages/DocumentLibrary'));
const InvoiceWarehousePrint = lazy(() => import('@/pages/InvoiceWarehousePrint'));

const routerConfig = [
  {
    path: '/admin',
    component: UserLayout,
    children: [
      {
        path: '/login',
        component: AdminLogin,
      },
      {
        path: '/',
        redirect: '/admin/login',
      },
    ],
  },
  {
    path: '/user',
    component: UserLayout,
    children: [
      {
        path: '/login',
        component: UserLogin,
      },
      {
        path: '/register',
        component: UserRegister,
      },
      {
        path: '/',
        redirect: '/user/login',
      },
      {
        component: NotFound,
      },
    ],
  },
  {
    path: '/',
    component: BasicLayout,
    children: [
      { path: '/brand', component: brand },
      { path: '/Provider', component: Provider },
      { path: '/ContractList', component: ContractList },
      { path: '/ContractDetailList', component: ContractDetailList },
      { path: '/contractManage', component: contractManage },
      { path: '/DocumentLibrary', component: DocumentLibrary },
      { path: '/BadDebtContractList', component: BadDebtContractList },
      { path: '/contractDashboard', component: contractDashboard },
      { path: '/ProjectCostReport', component: ProjectCostReport },
      { path: '/PurchaseList', component: PurchaseList },
      { path: '/ProviderList', component: ProviderList },
      { path: '/OutputExcel', component: OutputExcel },
      { path: '/TypeManager', component: TypeManager },
      { path: '/Approval', component: Approval },
      { path: '/PersonalApproval', component: PersonalApproval },
      { path: '/dashboard', component: Dashboard },
      { path: '/ProjectList', component: ProjectList },
      { path: '/users', component: users },
      { path: '/ContractInvoiceList', component: ContractInvoiceList },
      { path: '/ContractReceiveAmountList', component: ContractReceiveAmountList },
      { path: '/UnpaidReminder', component: UnpaidReminder },
      { path: '/PurchaseContractList', component: PurchaseContractList },
      { path: '/PurchaseInvoiceReminder', component: PurchaseInvoiceReminder },
      { path: '/FinancePayment', component: FinancePayment },
      { path: '/SupplierInvoiceLibrary', component: SupplierInvoiceLibrary },
      { path: '/InvoiceComparison', component: InvoiceComparison },
      { path: '/DataInspect', component: DataInspect },
      { path: '/AgentChat', component: AgentChat },
      { path: '/ContractTaxBreakdown', component: ContractTaxBreakdown },
      { path: '/StockManage', component: StockManage },
      { path: '/RoleManage', component: RoleManage },
      { path: '/MainCompanyManage', component: MainCompanyManage },
      { path: '/DataDictionary', component: DataDictionary },
      { path: '/EmployeeContract', component: EmployeeContract },
      { path: '/CompanyFixedAssetContracts', component: CompanyContract },
      { path: '/CompanyDailyContracts', component: CompanyContract },
      { path: '/CompanyExpenseInvoices', component: CompanyExpenseInvoice },
      { path: '/InvoiceWarehousePrint', component: InvoiceWarehousePrint },
      { path: '/', component: RootGate, exact: true },
      { component: NotFound },
    ],
  },
];

export default routerConfig;
